import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
import {Expression} from "abreact/expression/Expression";
 */
import { Expression } from "abreact/expression/Expression";
class ElementOptionImpl {
  constructor(type, isValid = true) {
    _defineProperty(this, "_type", void 0);
    _defineProperty(this, "_isValid", true);
    this._type = type;
    this._isValid = isValid;
  }
  get type() {
    return this._type;
  }
  get isValid() {
    return this._isValid;
  }
  set isValid(value) {
    this._isValid = value;
  }
  isOperatorOption() {
    return this.type === Expression.Domain.ElementOption.Type.OPERATOR;
  }
  isValueOption() {
    return this.type === Expression.Domain.ElementOption.Type.VALUE;
  }
  isFormulaOption() {
    return this.type === Expression.Domain.ElementOption.Type.FORMULA;
  }
  asOperatorOption() {
    if (this.isOperatorOption()) {
      return this;
    }
    throw new Error(`Cannot convert ${this.type} to an Expression.Domain.OperatorElementOption`);
  }
  asValueOption() {
    if (this.isValueOption()) {
      return this;
    }
    throw new Error(`Cannot convert ${this.type} to a Expression.Domain.ValueElementOption`);
  }
  asFormulaOption() {
    if (this.isFormulaOption()) {
      return this;
    }
    throw new Error(`Cannot convert ${this.type} to an ExpressionElementOption`);
  }
  toString() {
    return `type=${this.type}`;
  }
}
export class OperatorElementOptionImpl extends ElementOptionImpl {
  constructor(expOperator, valueCategoryID, valueTypeID, multiple, inclusionMessages = [], exclusionMessages = [], isValid = true) {
    super(Expression.Domain.ElementOption.Type.OPERATOR, isValid);
    _defineProperty(this, "_expOperator", void 0);
    _defineProperty(this, "_valueCategoryID", void 0);
    _defineProperty(this, "_valueTypeID", void 0);
    _defineProperty(this, "_multiple", void 0);
    _defineProperty(this, "_inclusionMessages", void 0);
    _defineProperty(this, "_exclusionMessages", void 0);
    this._expOperator = expOperator;
    this._valueCategoryID = valueCategoryID;
    this._valueTypeID = valueTypeID;
    this._multiple = multiple;
    this._inclusionMessages = inclusionMessages ? inclusionMessages : [];
    this._exclusionMessages = exclusionMessages;
  }
  get expOperator() {
    return this._expOperator;
  }
  get valueCategoryID() {
    return this._valueCategoryID;
  }
  get valueTypeID() {
    return this._valueTypeID;
  }
  get multiple() {
    return this._multiple;
  }
  get sortPriority() {
    return this.expOperator.sortPriority ?? Number.MIN_VALUE;
  }
  get inclusionMessages() {
    return this._inclusionMessages;
  }
  get exclusionMessages() {
    return this._exclusionMessages;
  }
  set exclusionMessages(value) {
    this._exclusionMessages = value;
  }
  compareTo(other) {
    return Expression.Domain.Operator.compare(this.expOperator, other.expOperator);
  }
  toString() {
    return `${super.toString()} expOperator=${this.expOperator}`;
  }
}
export class ValueElementOptionImpl extends ElementOptionImpl {
  constructor(expValueCategory, expValueType, multiple, isValid = true) {
    super(Expression.Domain.ElementOption.Type.VALUE, isValid);
    _defineProperty(this, "_expValueCategory", void 0);
    _defineProperty(this, "_expValueType", void 0);
    _defineProperty(this, "_multiple", void 0);
    this._expValueCategory = expValueCategory;
    this._expValueType = expValueType;
    this._multiple = multiple;
  }
  get expValueCategory() {
    return this._expValueCategory;
  }
  get expValueType() {
    return this._expValueType;
  }
  get valueCategoryID() {
    return this._expValueCategory.id;
  }
  get valueTypeID() {
    return this._expValueType.id;
  }
  get multiple() {
    return this._multiple;
  }
  toString() {
    return `${super.toString()} category=${this.valueCategoryID} valueType=${this.valueTypeID} multiple=${this.multiple}`;
  }
}
export class FormulaElementOptionImpl extends ElementOptionImpl {
  constructor(expValueCategory, expValueType, multiple) {
    super(Expression.Domain.ElementOption.Type.FORMULA, true);
    _defineProperty(this, "_expValueCategory", void 0);
    _defineProperty(this, "_expValueType", void 0);
    _defineProperty(this, "_multiple", void 0);
    this._expValueCategory = expValueCategory;
    this._expValueType = expValueType;
    this._multiple = multiple;
  }
  get expValueCategory() {
    return this._expValueCategory;
  }
  get expValueType() {
    return this._expValueType;
  }
  get valueCategoryID() {
    return this._expValueCategory.id;
  }
  get valueTypeID() {
    return this._expValueType.id;
  }
  get multiple() {
    return this._multiple;
  }
  toString() {
    return `${super.toString()} returnType=${this.valueCategoryID} ${this.valueTypeID} ${this.multiple}`;
  }
}
//# sourceMappingURL=ElementOptionImpl.js.map
